/** Where a Seat stands in one event's sale */
export enum SeatStatus {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
  RESERVED = 'reserved',
  OCCUPIED = 'occupied',
}

export const SeatStatusLabels: Record<SeatStatus, string> = {
  [SeatStatus.AVAILABLE]: 'Disponível',
  [SeatStatus.BLOCKED]: 'Bloqueado',
  [SeatStatus.RESERVED]: 'Reservado',
  [SeatStatus.OCCUPIED]: 'Vendido',
}

export const SeatStatusPlurals: Record<SeatStatus, string> = {
  [SeatStatus.AVAILABLE]: 'disponíveis',
  [SeatStatus.BLOCKED]: 'bloqueados',
  [SeatStatus.RESERVED]: 'reservados',
  [SeatStatus.OCCUPIED]: 'vendidos',
}

/** What the admin can do with a seat in this status; shown after the status label */
export const SeatStatusHints: Record<SeatStatus, string> = {
  [SeatStatus.AVAILABLE]: 'À venda. Pode ser bloqueado.',
  [SeatStatus.BLOCKED]: 'Fora de venda. Pode ser desbloqueado.',
  [SeatStatus.RESERVED]: 'Num carrinho ou aguardando pagamento. Não pode ser alterado.',
  [SeatStatus.OCCUPIED]: 'Não pode ser alterado.',
}

/** Available seats show no icon */
export const SeatStatusIcons: Record<SeatStatus, string | null> = {
  [SeatStatus.AVAILABLE]: null,
  [SeatStatus.BLOCKED]: 'fa-solid fa-lock',
  [SeatStatus.RESERVED]: 'fa-solid fa-hourglass-half',
  [SeatStatus.OCCUPIED]: 'fa-solid fa-ticket',
}

/** How the grid paints a seat in this status */
export const SeatStatusColors: Record<SeatStatus, { background: string, border: string, color: string }> = {
  [SeatStatus.AVAILABLE]: { background: '#ffffff', border: '#90a4ae', color: '#455a64' },
  [SeatStatus.BLOCKED]: { background: '#37474f', border: '#37474f', color: '#ffffff' },
  [SeatStatus.RESERVED]: { background: '#ffb300', border: '#ffa000', color: '#3e2723' },
  [SeatStatus.OCCUPIED]: { background: '#1e88e5', border: '#1976d2', color: '#ffffff' },
}

/** Only available and blocked seats can be blocked or unblocked: reserved and sold ones belong to a buyer */
export function isChangeable(status: SeatStatus): boolean {
  return status === SeatStatus.AVAILABLE || status === SeatStatus.BLOCKED
}
